module.exports = __webpack_public_path__ + "img/momo_home_bg_6.bb02248a.png";